
import loading from "../../assests/loading .gif"
import nologs from "../../assests/nologs.gif"
import CustomTooltip from "../Buttons/CustomTooltip"

// **MODIFIED: Now receives log data as props instead of managing WebSocket internally**
function LogModelForDbMigration({
  logshow,
  logsetShow,
  jobId,
  fileId,
  jobName,
  tableName,
  // **NEW: Props from centralized log management**
  logs,
  isLogLoading,
  fileProcessCompleted,
  jobProcessCompleted,
  isStreaming,
}) {
  const handlelogClose = () => logsetShow(false)

  const truncateText = (text, maxLength) => {
    if (!text) return "N/A"

    const isTruncated = text.length > maxLength
    const truncated = isTruncated ? `${text.substring(0, maxLength)}...` : text

    return isTruncated ? (
      <CustomTooltip
        content={text}
        placement="right"
        fallbackPlacements={["top"]} // fallback only to bottom
      >
        <span className="truncated-text" style={{ cursor: "pointer" }}>
          {truncated}
        </span>
      </CustomTooltip>
    ) : (
      <span>{text}</span>
    )
  }

  // **REMOVED: All WebSocket logic (useEffect with WebSocket connection)**
  // This logic is now handled in the parent DBMigration component

  // Determine completion status and message based on whether we're viewing file or job logs
  const processCompleted = fileId ? fileProcessCompleted : jobProcessCompleted
  const completionMessage = fileId ? "File processing completed! ✅" : "Job processing completed! ✅"
  const inProgressMessage = fileId ? "File conversion in progress...🛠️" : "Job conversion in progress...🛠️"
  const descriptionMessage = processCompleted
    ? fileId
      ? "File processing has been completed successfully!"
      : "All files in this job have been processed successfully!"
    : "Your data is on its way to the destination. Sit tight, and we'll notify you once it's done."

  const logContainerStyle =
    (logs?.length || 0) > 0
      ? { height: "40vh", overflowY: "auto" }
      : {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "40vh",
        }

  const highlightKeywords = (text) => {
    if (!text) return text
    const greenKeywords = ["completed", "successfully"]
    const yellowKeywords = ["SQL", "T-SQL", "output", "progress", "Transforming", "Converting", "folder", "file"]
    const redKeywords = ["of", "table", "queries", "Transformimg"]
    const newWords = ["Started", "database", "data"]
    const errorWords = ["error", "failed"]

    const regex = new RegExp(
      `\\b(${[...greenKeywords, ...yellowKeywords, ...redKeywords, ...newWords, ...errorWords].join("|")})\\b`,
      "gi",
    )

    return text.split(regex).map((part, index) => {
      if (greenKeywords.some((word) => word.toLowerCase() === part.toLowerCase())) {
        return (
          <span key={index} style={{ color: "#57FFEF", fontWeight: "bold" }}>
            {part}
          </span>
        )
      } else if (yellowKeywords.some((word) => word.toLowerCase() === part.toLowerCase())) {
        return (
          <span key={index} style={{ color: "#FFD03C", fontWeight: "bold" }}>
            {part}
          </span>
        )
      } else if (redKeywords.some((word) => word.toLowerCase() === part.toLowerCase())) {
        return (
          <span key={index} style={{ color: "#F97583", fontWeight: "bold" }}>
            {part}
          </span>
        )
      } else if (newWords.some((word) => word.toLowerCase() === part.toLowerCase())) {
        return (
          <span key={index} style={{ color: "#B392F0", fontWeight: "bold" }}>
            {part}
          </span>
        )
      } else if (errorWords.some((word) => word.toLowerCase() === part.toLowerCase())) {
        return (
          <span key={index} style={{ color: "#ec9395", fontWeight: "bold" }}>
            {part}
          </span>
        )
      }

      return part
    })
  }

  return (
    <div className={`right-bar2 p-3 ${logshow ? "d-block" : "d-none"}`}>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.6; }
            50% { opacity: 0.3; }
            100% { opacity: 0.6; }
          }
          
          /* Fix for DB migration tooltip positioning */
          .right-bar2 .custom-tooltip {
            z-index: 10000 !important;
            position: fixed !important;
          }
          
          .custom-tooltip[data-popper-placement^='left'] > .react-tooltip-arrow {
            border-left-color: #e0b8ff !important;
          }
          
          /* Ensure the close button container doesn't interfere */
          .right-bar2 .d-flex.align-item-center.justify-content-between {
            position: relative;
            z-index: 1;
          }
        `}
      </style>
      <div data-simplebar className="h-100">
        <div className="d-flex align-item-center justify-content-between">
          <p className="mb-0 fw-medium text-dark fw-bold">Logs</p>
          <div style={{ position: "relative", zIndex: 10 }}>
            <CustomTooltip
              content="Close"
              placement="left"
              fallbackPlacements={["top-end", "top"]}
              offset={[-10, 0]}
              delayShow={200}
            >
              <i
                onClick={handlelogClose}
                className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor"
              />
            </CustomTooltip>
          </div>
        </div>
        <div className="d-flex align-item-center justify-content-between pt-2">
          <div>
            <h6 className="text-dark fw-bold mb-0 mt-1">
              Logs for {fileId ? "File" : "Job"}:{" "}
              <span className="text-primary">
                {fileId ? truncateText(tableName, 18) : truncateText(jobName, 15) || "N/A"}
              </span>{" "}
              {processCompleted ? completionMessage : inProgressMessage}
            </h6>
            <p className="font-size-11 mt-2 mb-3">{descriptionMessage}</p>
          </div>
        </div>

        <div className="p-3 card-calc" style={logContainerStyle}>
          {/* **MODIFIED: Now uses isLogLoading prop instead of local loading state** */}
          {isLogLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
              <img src={loading || "/placeholder.svg"} alt="Loading..." style={{ width: "20%", height: "auto" }} />
            </div>
          ) : logs?.length > 0 ? (
            <div className="log-container" style={{ fontSize: "14px", fontFamily: "Helvetica" }}>
              <div
                style={{
                  display: "flex",
                  paddingBottom: "8px",
                }}
              >
                <div
                  style={{
                    width: "23%",
                    color: "white",
                    paddingRight: "16px",
                  }}
                >
                  Timestamp
                </div>
                <div
                  className="Log-width Log-padding"
                  style={{
                    width: "26%",
                    color: "white",
                    paddingRight: "16px",
                    paddingLeft: "50px",
                  }}
                >
                  Table Name
                </div>
                <div
                  style={{
                    width: "52%",
                    color: "white",
                    paddingLeft: "16px",
                  }}
                >
                  Summary
                </div>
              </div>

              {logs.map((log, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    padding: "6px 0",
                    fontSize: "12px",
                    fontFamily: "'JetBrains Mono', monospace",
                    minHeight: "40px",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    style={{
                      width: "23%",
                      color: "white",
                      paddingRight: "16px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {log.timestamp}
                  </div>
                  <div
                  className="Log-width"
                    style={{
                      width: "26%",
                      color: "white",
                      paddingRight: "16px",
                      paddingLeft: "52px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {log.table_name || "N/A"}
                  </div>
                  <div
                    style={{
                      width: "52%",
                      color: "white",
                      paddingLeft: "16px",
                      wordBreak: "break-word",
                    }}
                  >
                    {highlightKeywords(log.message)}
                  </div>
                </div>
              ))}

              {/* **MODIFIED: Now uses isStreaming and processCompleted props** */}
              {isStreaming && !processCompleted && (
                <div
                  style={{
                    display: "flex",
                    padding: "6px 0",
                    fontSize: "12px",
                    fontFamily: "'JetBrains Mono', monospace",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: 2, paddingRight: "12px" }}>
                    <div
                      style={{
                        width: "100%",
                        height: "14px",
                        backgroundColor: "rgb(160 168 181 / 31%)",
                        borderRadius: "2px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                  </div>
                  <div style={{ flex: 1, paddingRight: "12px" }}>
                    <div
                      style={{
                        width: "40%",
                        height: "14px",
                        backgroundColor: "rgb(160 168 181 / 31%)",
                        borderRadius: "2px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                  </div>
                  <div style={{ flex: 3, minWidth: 0 }}>
                    <div
                      style={{
                        width: "90%",
                        height: "14px",
                        backgroundColor: "rgb(160 168 181 / 31%)",
                        borderRadius: "2px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                    <div
                      style={{
                        width: "70%",
                        height: "14px",
                        backgroundColor: "rgb(160 168 181 / 31%)",
                        borderRadius: "2px",
                        marginTop: "4px",
                        animation: "pulse 1.5s infinite",
                        animationDelay: "0.3s",
                      }}
                    ></div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "200px" }}>
              <img src={nologs || "/placeholder.svg"} alt="No Logs..." style={{ width: "30%", height: "auto" }} />
              <p>No Logs Available</p>
            </div>
          )}
        </div>

        <div className="position-absolute w-100 bottom-2px" style={{ paddingBottom: "0px" }}>
          <div className="d-flex justify-content-between">
            <button onClick={handlelogClose} className="btn btn-closebtn custom-button">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LogModelForDbMigration
